import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { submitRequest } from "./requests";

var base = function base(_ref) {
  var state = _ref.state;
  return {
    state: state
  };
}; // Success object factories


var success = function success(_ref2) {
  var action = _ref2.action;
  return _objectSpread(_objectSpread({}, base({
    state: "success"
  })), {}, {
    action: action
  });
};

var inlineMessage = function inlineMessage(_ref3) {
  var message = _ref3.message;
  return _objectSpread(_objectSpread({}, success({
    action: "inlineMessage"
  })), {}, {
    message: message
  });
};

var redirect = function redirect(_ref4) {
  var location = _ref4.location;
  return _objectSpread(_objectSpread({}, success({
    action: "redirect"
  })), {}, {
    location: location
  });
};

var unknown = function unknown(_ref5) {
  var exception = _ref5.exception;
  return _objectSpread(_objectSpread({}, success({
    action: "unknown"
  })), {}, {
    exception: exception
  });
}; // Fail object factories


var failure = function failure(_ref6) {
  var failType = _ref6.failType;
  return _objectSpread(_objectSpread({}, base({
    state: "failure"
  })), {}, {
    failType: failType
  });
};

var failException = function failException(_ref7) {
  var exception = _ref7.exception;
  return _objectSpread(_objectSpread({}, failure({
    failType: "exception"
  })), {}, {
    exception: exception
  });
};

var failMessage = function failMessage(_ref8) {
  var message = _ref8.message;
  return _objectSpread(_objectSpread({}, failure({
    failType: "message"
  })), {}, {
    failMessage: message
  });
};
/**
 * Submits a form asynchronously.
 *
 * Arguments:
 * `path`: where the form should be submitted
 * `formData`: the `FormData` representing the form. See https://developer.mozilla.org/en-US/docs/Web/API/FormData
 *
 * Will always return an object with the following structure:
 *
 * {
 *   state: string(success|failure) // always set
 *
 *   action?: string(inlineMessage|redirect|unknown), // always set when state == success
 *   location?: string, // always set when action == redirect
 *   message?: string, // always set when action == inlineMessage. sometimes set when state == fail
 *
 *   failMessage?: string, // always set when failType == message
 *   failType?: string(exception|message), // always set when state == failure
 *
 *   exception?: Error|string, // always set when failType == exception, may be set when action == unknown
 * }
 */


export default /*#__PURE__*/(function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, formData) {
    var jsonData, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return submitRequest(path, formData);

          case 3:
            response = _context.sent;
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", failException({
              exception: _context.t0
            }));

          case 9:
            _context.prev = 9;
            _context.next = 12;
            return response.json();

          case 12:
            jsonData = _context.sent;
            _context.next = 20;
            break;

          case 15:
            _context.prev = 15;
            _context.t1 = _context["catch"](9);

            if (!response.ok) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", unknown({
              exception: _context.t1
            }));

          case 19:
            return _context.abrupt("return", failException({
              exception: _context.t1
            }));

          case 20:
            if (!response.ok) {
              _context.next = 27;
              break;
            }

            _context.t2 = jsonData.action;
            _context.next = _context.t2 === "redirect" ? 24 : _context.t2 === "inlineMessage" ? 25 : 26;
            break;

          case 24:
            return _context.abrupt("return", redirect({
              location: jsonData.location
            }));

          case 25:
            return _context.abrupt("return", inlineMessage({
              message: jsonData.message
            }));

          case 26:
            return _context.abrupt("return", unknown({}));

          case 27:
            return _context.abrupt("return", failMessage({
              message: jsonData.message
            }));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6], [9, 15]]);
  }));

  return function (_x, _x2) {
    return _ref9.apply(this, arguments);
  };
})();